import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin, Observable } from 'rxjs';
import { PlateService } from './core/plates/plates.service';
import { SiteService } from './core/sites/site.service';
import { UserService } from './core/user/user.service';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any> {
    /**
     * Constructor
     * @param _navigationService
     * @param _userService
     * @param _siteService
     * @param _plateService
     */
    constructor(private _plateService: PlateService, private _navigationService: NavigationService, private _userService: UserService, private _siteService: SiteService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
            this._navigationService.get(),
            this._userService.get(),
            this._siteService.getSites(),
            this._plateService.getPlates()
        ]);
    }
}
